export const ESC = 27;
export const TAB = 9;
export const DOWN = 40;
export const UP = 38;
export const ENTER = 13;
